// extracted by mini-css-extract-plugin
export var content = "_lr-1";
export var fullScreen = "_lr-0";